export default {"src":"/_next/static/media/girl.fe24cfaf.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};